import { render, staticRenderFns } from "./ChatChartBlock.vue?vue&type=template&id=1917e1b8&scoped=true"
import script from "./ChatChartBlock.vue?vue&type=script&lang=js"
export * from "./ChatChartBlock.vue?vue&type=script&lang=js"
import style0 from "./ChatChartBlock.vue?vue&type=style&index=0&id=1917e1b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1917e1b8",
  null
  
)

export default component.exports